<template>
    <div class="calculadora-plano">
      <header-primary
        title="Calculadora de Planos"
        subtitle="Veja qual plano é ideal para o seu dia-a-dia!"
        :image="require('../assets/background/bg_lines_connect.png')"></header-primary>
      <div class="container">
        <div class="row d-flex">
          <iframe
            frameborder="0" class="d-flex flex-grow-1 m-0" style="height: 640px;"
            src="http://172.20.34.3/invirtex2/vtxcalculadora.html" >
          </iframe>
        </div>
        <button-large-light
          titulo="Não conhece nossos planos?"
          sub-titulo="Clique e veja o que temos a lhe oferecer!"
          :link="`/${$route.params.cidade}/planos`"
          class="mb-5"></button-large-light>
      </div>
    </div>
</template>

<script>
    import HeaderPrimary from "../components/HeaderPrimary";
    import ButtonLargeLight from "../components/ButtonLargeLight";
    export default {
        name: "CalculadoraPlano",
      components: {ButtonLargeLight, HeaderPrimary}
    }
</script>

<style scoped>

</style>
